module.exports = __webpack_public_path__ + "static/media/nugl_cross.0ad19889.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/nugl_cross.svg
// module id = 372
// module chunks = 0